import PropTypes from "prop-types"
import { Grid } from "@mui/material"
import { LIST_ITEM_TEXT_OPTION } from "helpers/shapes"
import { METRICS } from "helpers/metrics/constants"
import DefaultMetricUnits from "modules/default-metric-units"
import { TotalRow, Panel, PanelHeader, FactorCategories } from "components/factor-view"
import Table from "components/material/table"
import ListItemDropdown from "components/list-item-dropdown"
import classNames from "classnames"
import Bolt from "./bolt"

import "./styles.scss"

export default function AnalyzeFactorsContent({
  type,
  columns,
  totalColumns,
  categoriesColumns,
  totalRow,
  categories,
  selectedFactorCategory,
  setFactorCategory,
  startDate,
  endDate,
  isActive,
  titlePrefix,
  factors,
  metricType,
  setMetricType,
  metricTypeOptions,
  displayMetricSelector,
}) {
  const isPerformanceView = type === METRICS.PERFORMANCE
  const defaultMetricsListAction = isPerformanceView ? <DefaultMetricUnits metric={type} unit={metricType} /> : null
  return <div className={classNames("component_analyze-factors-content", type)}>
    <Grid container spacing={2}>
      <Panel className="panel left">
        <div className="content">
          {isPerformanceView && displayMetricSelector && <div className="view-options">
            <ListItemDropdown label="Display" value={metricType} setValue={setMetricType} options={metricTypeOptions} alignMenu="left" listAction={defaultMetricsListAction} classes={{ toggle: "metricType" }} />
          </div>}
          <TotalRow row={totalRow} columns={totalColumns} />
          <FactorCategories {...{ categories, selectedFactorCategory, setFactorCategory, columns: categoriesColumns }} />
        </div>
      </Panel>

      <Panel className="panel right">
        <PanelHeader>
          {isPerformanceView && <span className="single-item-menu"><Bolt {...{ startDate, endDate, isActive }} /><span>{titlePrefix} attribution</span></span>}
          {type === "risk" && <span className="single-item-menu">{titlePrefix} attribution</span>}
        </PanelHeader>
        <div className="content">
          <Table
            idField="id"
            data={factors}
            showToolbar={false}
            addForm={false}
            columns={columns}
            allowAbsoluteSort
          />
        </div>
      </Panel>
    </Grid>
  </div>
}

AnalyzeFactorsContent.propTypes = {
  type: PropTypes.oneOf(["performance", "risk"]).isRequired,
  titlePrefix: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  totalColumns: PropTypes.array.isRequired,
  categoriesColumns: PropTypes.array.isRequired,
  totalRow: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  selectedFactorCategory: PropTypes.string.isRequired,
  setFactorCategory: PropTypes.func.isRequired,
  factors: PropTypes.array.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  isActive: PropTypes.bool,
  metricType: PropTypes.string,
  setMetricType: PropTypes.func.isRequired,
  metricTypeOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
  displayMetricSelector: PropTypes.bool,
}
